import axios from 'axios';

class SuperAdminService {
    static getAllUsers = (page = 1, limit = 20, search = '') =>
        axios.get('/super-admin/users', { params: { page, limit, search } });

    static getUserDetails = (userId) =>
        axios.get(`/super-admin/users/${userId}`);
}

export default SuperAdminService;
